// Emotion types
/// <reference types="@emotion/react/types/css-prop" />
import { css } from "@emotion/react";
import styled from "@emotion/styled";
// Subtitles
import campaignSubs from "file-loader!../assets/subtitles/campaign-fi.vtt";
import React, { useRef, useEffect, useState } from "react";

// Images
import datacenter from "../assets/images/datacenter.jpg";
import solar from "../assets/images/solar.jpg";
import wind from "../assets/images/wind.jpg";
import snowmobile from "../assets/images/snowmobile.jpg";
import aviation from "../assets/images/aviation.jpg";
import fullImg from "../assets/images/full-img.jpg";
import transportTruck from "../assets/images/transport-truck.jpg";

// Video
import oceanWebM from "../assets/videos/ocean.webm";
import oceanMp4 from "../assets/videos/ocean.mp4";

import campaignMp4 from "../assets/videos/campaign-fi.mp4";
import campaignWebM from "../assets/videos/campaign-fi.webm";
import cloudsMp4 from "../assets/videos/clouds.mp4";
import cloudsWebM from "../assets/videos/clouds.webm";
//import steelMp4 from "../assets/videos/steel.mp4";
//import steelWebm from "../assets/videos/steel.webm";

import {
    Button,
    Case,
    FooterFi,
    Headline,
    HeroText,
    Layout,
    Map,
    Metadata,
    NavigationFi,
    VideoHero,
    locationsFinnish,
} from "../components";

// Styling

const StickyBtn = styled.a`
    position: sticky;
    top: 80px;
    z-index: 10;
`;

const FullImg = styled.div`
    position: relative;
    @media screen and (max-width: 768px) {
        margin-top: 0;
        margin-bottom: 0;
    }
    h2 {
        position: absolute;
        color: #fff;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        max-width: 470px;
        @media screen and (max-width: 768px) {
            font-size: 25px;
            line-height: 24px;
            top: 40%;
            width: 100%;
        }
    }
    img {
        width: 100%;
        @media screen and (max-width: 768px) {
            height: 200px;
            object-fit: cover;
            object-position: center;
        }
    }
`;

// Markup
export const Finnish = () => {
    const steelRef = useRef<HTMLDivElement>(null);
    const datacenterRef = useRef<HTMLDivElement>(null);
    const aviationRef = useRef<HTMLDivElement>(null);
    const oceanRef = useRef<HTMLDivElement>(null);
    const solarRef = useRef<HTMLDivElement>(null);
    const snowmobileRef = useRef<HTMLDivElement>(null);
    const roadRef = useRef<HTMLDivElement>(null);

    const [zoom, setZoom] = useState(4.2);

    useEffect(() => {
        window.innerWidth > 768 ? setZoom(4.2) : setZoom(3.3);
    }, [zoom])

    // Order important for scrollTo, same as array of map-markers
    const articleRefs = [
        steelRef,
        oceanRef,
        aviationRef,
        solarRef,
        snowmobileRef,
        datacenterRef,
        roadRef
    ];

    return (
        <>
            <Metadata />
            <NavigationFi />
            <Layout>
                <VideoHero
                    primary
                    webM={campaignWebM}
                    mp4={campaignMp4}
                    subtitles={campaignSubs}
                    subLang="fi"
                    subLabel="Suomalainen"
                >
                    {/*<h1>Bli en del av bra saker för klimatet</h1>*/}
                </VideoHero>

                <p>
                    Aika tehdä uusi sähkösopimus{" "}
                    <a href="https://www.vattenfall.fi/sahkosopimukset/">
                        kotiin
                    </a>{" "}
                    tai{" "}
                    <a href="https://www.vattenfall.fi/yritysasiakkaat/pienyritykset/">
                        yritykselle
                    </a>
                    ? <br /> Tee valinta, joka on yhtä aikaa sekä helppo että
                    tärkeä.
                </p>

                <StickyBtn
                    style={{ marginTop: 0 }}
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.vattenfall.fi/sahkosopimukset/"
                >
                    <Button intent="primary">
                        Tee fossiilivapaa sähkösopimus
                    </Button>
                </StickyBtn>
                <VideoHero webM={oceanWebM} mp4={oceanMp4}>
                    <HeroText color="#fff">
                        Ole mukana matkalla kohti fossiilivapaata huomista.
                        Sinun tarvitsee vain valita fossiilivapaa sähkösopimus.
                    </HeroText>
                </VideoHero>
                <Headline
                    primary="Matkalla kohti hyviä asioita"
                    secondary="Ohessa muutamia esimerkkejä kehityksestä, jossa olet mukana."
                />
                <Map
                    articleRefs={articleRefs}
                    data={locationsFinnish}
                    zoom={zoom}
                />

                {/*<VideoHero
                    webM={steelWebm}
                    mp4={steelMp4}
                    ref={steelRef}
                    primary
                ></VideoHero>*/}

                <FullImg ref={steelRef}>
                    <h2>
                        Fossiiliton teräs tuotetaan fossiilivapaalla sähköllä
                    </h2>
                    <img src={fullImg} alt="img" style={{ width: "100%" }} />
                </FullImg>

                <div style={{ maxWidth: "620px", textAlign: "center" }}>
                    <h2>
                        Fossiilivapaan teräksen kehitys voi vähentää maailman
                        hiilidioksidipäästöjä 7 %
                    </h2>

                    <div style={{ marginTop: "35px" }}>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.vattenfall.fi/fokuksessa/innovaatiot/hybrit-tekee-teraksen-valmistuksesta-fossiilivapaata/"
                        >
                            <Button intent="primary">Lue lisää</Button>
                        </a>
                    </div>
                </div>

                <Case
                    ref={oceanRef}
                    image={wind}
                    imageOn="right"
                    offset={50}
                    backgroundColor="#EDF1F6"
                >
                    <h4>Energiaa mereltä</h4>
                    <p>
                        Korkean huipunkäyttöajan ansiosta merituulivoiman
                        tuotanto sopii erityisen hyvin fossiilivapaan vedyn
                        tuotantoon. AquaVentus-hanke mahdollistaa 10 GW
                        meripohjaista vetykapasiteettia Pohjanmerellä vuoteen
                        2035 mennessä.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.fi/fokuksessa/innovaatiot/kelluva-tuulivoima-nousussa/"
                    >
                        Lue lisää
                    </a>
                </Case>
                <Case
                    ref={aviationRef}
                    image={aviation}
                    imageOn="left"
                    offset={50}
                    backgroundColor="#EDF1F6"
                >
                    <h4>Fossiilivapaa lentopolttoaine</h4>
                    <p>
                        Fossiilivapaan sähköpolttoaineen kehitys mahdollistaa
                        sen, että voimme pian lentää paremmalla omallatunnolla.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.fi/fokuksessa/innovaatiot/nain-lentamisesta-tulee-fossiilitonta/"
                    >
                        Lue lisää
                    </a>
                </Case>
                <Case
                    ref={solarRef}
                    image={solar}
                    imageOn="right"
                    offset={50}
                    backgroundColor="#F2F2F2"
                >
                    <h4>Lisää aurinkovoimaa</h4>
                    <p>
                        Aurinkopaneelit ovat entistä tavallisempi näky. Yhä
                        useammat kodit ovat voimalaitoksia, jotka hyödyntävät
                        auringon ilmaista energiaa.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.fi/fokuksessa/koti/ruotsin-modernein-ekotalo-tuottaa-sahkoa-aurinkoenergialla"
                    >
                        Lue lisää
                    </a>
                </Case>
                <Case
                    ref={snowmobileRef}
                    image={snowmobile}
                    imageOn="left"
                    offset={50}
                    backgroundColor="#EDF1F6"
                >
                    <h4>Sähkömoottorikelkat</h4>
                    <p>
                        Kuvittele itsesi kiitämässä äänettömästi pitkin erämaata
                        jäätyneiden järvien ja tuntureiden yli. Se on
                        mahdollista, sillä sähkökäyttöiset moottorikelkat ovat
                        juuri tulleet markkinoille.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.fi/fokuksessa/innovaatiot/sahkomoottorikelkoista-ilmastoalykas-vaihtoehto-maastokayttoon/"
                    >
                        Lue lisää
                    </a>
                </Case>
                <Case
                    ref={datacenterRef}
                    image={datacenter}
                    imageOn="right"
                    offset={50}
                    backgroundColor="#F2F2F2"
                >
                    <h4>Fossiilivapaat datakeskukset</h4>
                    <p>
                        Datakeskukset eli konesalit tai palvelukeskukset ovat
                        digitalisoituvan maailmamme todellisia
                        energia-ahmatteja. Monet suuret yritykset siirtävät
                        datakeskuksiaan Pohjoismaihin vähentääkseen
                        hiilidioksidipäästöjään.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.fi/fokuksessa/innovaatiot/pohjoismaista-ratkaisu-ilmastoalykkaisiin-datakeskuksiin"
                    >
                        Lue lisää
                    </a>
                </Case>
                <Case
                    ref={roadRef}
                    image={transportTruck}
                    imageOn="left"
                    offset={50}
                    backgroundColor="#F2F2F2"
                >
                    <h4>Sähkötie</h4>
                    <p>
                        Maailman ensimmäinen langaton sähkötie busseille ja
                        raskaalle kalustolle on valmis. Nyt voi raskas liikenne
                        kulkea lentokentän ja Visbyn välillä täysin sähköllä.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.fi/fokuksessa/innovaatiot/sahkotie-lataa-ajaessa/"
                    >
                        Lue lisää
                    </a>
                </Case>
                <VideoHero webM={cloudsWebM} mp4={cloudsMp4} minHeight>
                    <h2>Uusiutuvaa vai fossiilivapaata sähköä?</h2>
                    <div
                        css={css`
                            max-width: 705px;
                        `}
                    >
                        <HeroText small color="#fff">
                            Kaikki Suomessa myymämme sähkö on fossiilivapaata.
                            Se tarkoittaa, että sähkö tuotetaan käytännössä
                            täysin ilman hiilidioksidipäästöjä. Osa
                            sähköntuotantoon käytetystä energiasta on myös
                            uusiutuvaa.
                        </HeroText>
                        <HeroText small color="#fff">
                            Halutessasi voit valita sähkösopimuksesi
                            tuotantomuodon ilman lisämaksua.
                        </HeroText>
                    </div>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.fi/sahkosopimukset/tuotantomuodot/"
                    >
                        <Button intent="secondary">Lue lisää</Button>
                    </a>
                </VideoHero>
            </Layout>
            <FooterFi />
        </>
    );
};
